export type DeliveryMethodValue = '1' | '2' | '3';

export interface RadioOption<T extends number | string> {
  title: string;
  description?: string;
  value: T;
}

export const deliveryOptions: RadioOption<DeliveryMethodValue>[] = [
  {
    title: 'ارسال با تیپاکس',
    description: 'هزینه بر عهده خریدار',
    value: '2',
  },
  {
    title: 'ارسال با باربری',
    description: 'هزینه بر عهده خریدار',
    value: '3',
  },
  {
    title: 'ارسال با پست',
    description: 'هزینه بر عهده فروشنده',
    value: '1',
  },
];
